import { Switch } from "../../components/switch";

export const InlineSwitch = ({
  checked,
  onChange
}: {
  checked: boolean,
  onChange: (checked: boolean) => void
}) => {
  return (
    <Switch
      color="green"
      checked={checked}
      onChange={onChange}
    />
  );
};